const DrawerTypes = {
	CREATE: 'CREATE',
	EDIT: 'EDIT',
	DELETE: 'DELETE',
	MANAGE: 'MANAGE',
};

export default DrawerTypes;
